import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { userAcccountTableOneColumn} from '../../datatablesource'
import { handleError } from '../../utils/error'
import newRequest from '../../utils/newRequest'
import Datatable from '../datatable/Datatable'
import './userAccount.scss'
import { useTranslation } from "react-i18next";

const UserAccount = () => {
  const navigate = useNavigate();
  const [userAccountList, setUserAccountList] = useState([]);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const getAllUserAccountList = async () => {
      try {
        const response = await newRequest.get("/GetAllusers")
        setIsAuthenticating(false);
        let newData = response.data.map((item) => {
          return {
            ...item,
            loginpass: "****"
          }
        })
        setUserAccountList(newData);
      }
      catch (error) {
        handleError(error)
        setIsAuthenticating(false);
      }
    };
    getAllUserAccountList();
  }, []);

  return (
    <div className="userAccountComContainer w-full flex justify-between">
      <>
        <span className="mainSpain w-full">
          <Datatable
            columnsName={userAcccountTableOneColumn(t)}
            data={userAccountList}
            secondaryColor="secondary"
            title={t("USER ACCOUNTS")}
            uniqueId={"userAccountId"}
            loading={isAuthenticating}
            deleteBtnEndPoint="/DeleteusersById"
            checkboxSelectionOption={false}
            addNewNavigation="/admin/users-account/add-new-user"
          />
        </span>
      </>
    </div>
  );
}

export default UserAccount